import { ReadAtHomeSurvey } from "common/build/prisma/client";
import { postData } from "../rest";

export const completeReadAtHomeSurvey = async (survey: Partial<ReadAtHomeSurvey>): Promise<Response> =>
    await postData(`/public/survey`, { ...survey });
